import { render } from "./QuizSettingsForm.vue?vue&type=template&id=895ce024"
import script from "./QuizSettingsForm.vue?vue&type=script&lang=js"
export * from "./QuizSettingsForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__